import styled from 'styled-components'
import { Spacings } from '@styles'

const HeaderRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	// margin-bottom: ${Spacings.SPACING_2B};
	width: 100%;
	font-family: ${({ theme }) => theme.fontFamily.inter || "'Inter', sans-serif"};
`

export default HeaderRow
